export class DraftEmail {
    public id: number = null;
    public organizationId: string = null;
    public viewId: number = null;
    public folderId: string = null;
    public creationDate: Date = null;
    public updateDate: Date = null;

    public attachments: string;
    public userId: string = null;

    private _content: string = null;
    private _contentObject: object = null;

    public get content(): string {
        return this._content;
    }

    public set content(value: string) {
        this._content = value;
        this._contentObject = JSON.parse(this._content);
        this._subject = undefined;
    }

    private _subject = undefined;

    public get subject(): string {
        if (this._subject === undefined) {
            this._subject = this._contentObject['subject'];
        }

        return this._subject;
    }

    private _to = undefined;

    public get to(): Array<string> {
        if (this._to === undefined) {
            this._to = this._contentObject['to'];
        }

        return this._to;
    }

    public static from(other: any) {
        if (!!other) {
            const instance = new DraftEmail();

            instance.id = other.id;
            instance.organizationId = other.organizationId;
            instance.viewId = other.viewId;
            instance.folderId = other.folderId;
            instance.creationDate = new Date(Date.parse(other.creationDate));
            instance.updateDate = new Date(Date.parse(other.updateDate));
            instance.content = other.content;
            instance.attachments = other.attachments;
            instance.userId = other.userId;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne un tableau d'instances de DraftEmail à partir d'un tableau d'instances de Any.
     * @param other : Tableau d'instances de Any.
     * @returns : Tableau d'instances de DraftEmail.
     */
    public static fromArray(others: any[]) {
        if (!!others) {
            let drafts: DraftEmail[] = [];

            others.forEach((x) => {
                const draft = DraftEmail.from(x);
                drafts.push(draft);
            });

            return drafts;
        } else {
            return null;
        }
    }
}
